/**
 * PaymentCancel - Payment cancellation page
 * Redirects user back to plans
 */
import React from "react";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { useTranslation } from "../translations";
import { ArrowLeft } from "lucide-react";

const PaymentCancel = ({ onNavigate }) => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <Card className="w-full max-w-md" data-testid="payment-cancel-card">
        <CardContent className="pt-8 pb-8 text-center">
          <div className="w-16 h-16 mx-auto bg-gray-100 rounded-full flex items-center justify-center mb-4">
            <ArrowLeft className="w-8 h-8 text-gray-500" />
          </div>
          <h2 className="text-xl font-bold text-gray-800 mb-2">{t('paymentCancelled') || 'Pagamento cancelado'}</h2>
          <p className="text-gray-600 mb-6">{t('paymentCancelledDesc') || 'Nenhuma cobrança foi feita. Você pode voltar e escolher um plano quando quiser.'}</p>
          <Button
            data-testid="back-to-plans-btn"
            className="bg-blue-600 hover:bg-blue-700 w-full"
            onClick={() => {
              window.history.pushState({}, '', '/');
              if (onNavigate) onNavigate('plans');
              else window.location.href = '/';
            }}
          >
            {t('backToPlans') || 'Voltar aos Planos'}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentCancel;
